module.exports = __webpack_public_path__ + "img/hyl_picturebox.24af4ffd.png";